export class NameValidator {
  private static readonly regexPattern = /^[a-zA-Z\u0600-\u06FF-]+$/; // Arabic characters, English letters, and hyphens
  private static readonly minNameCount = 4;
  private static readonly minNameLength = 2;
  private static readonly maxNameLength = 15;

  static validateInput(input: string): boolean {
    const trimmedInput = input.trim();
    const names = trimmedInput.split(' ');

    if (names.length < this.minNameCount) {
      return false;
    }

    for (const name of names) {
      if (!this.isNameLengthValid(name) || !this.isNameContainsAllowedChars(name)) {
        return false;
      }
    }

    return true;
  }

  static isNameContainsAllowedChars(name: string): boolean {
    return this.regexPattern.test(name);
  }

  static isNameLengthValid(name: string): boolean {
    return name.length >= this.minNameLength && name.length <= this.maxNameLength;
  }
}
